export const reducer = (handlers, initialState = { }) => (state = initialState, action = {}) => handlers[action.type]?.(state, action) ?? state;
